<template>
  <div id="container" class="">
    <div class="header_menu">
      <ul>
        <li class="active"><a href="/">{{$t('base.home')}}</a></li>
        <li>
          <router-link :to="{path:'/market?type=auction'}">{{$t('base.auction')}}</router-link>
        </li>
        <li>
          <router-link :to="{path:'/market?type=buy'}">{{$t('base.buyNow')}}</router-link>
        </li>
        <li>
          <router-link :to="{path:'/market?type=like'}">{{$t('base.newly')}}</router-link>
        </li>
        <template v-if="SearchCategory.length>0">
          <li class="shopCardHobby">
            <router-link :to="{path:'/list'}">{{$t('base.shopCardHobby')}}</router-link>
            <div class="shopCardHobbyBox">
              <router-link class="logobox" v-for="(item,index) in SearchCategory" :key="index" :to="{path:'/list',query:{type:item.Title,index:index}}" target="_blank">
                      <img :src="item.ImgSelectedUrl">
                    </router-link>
            </div>
          </li>
        </template>
      </ul>
    </div>
    <!-- banner -->
    <av-swiper />
    <!-- <i18n path="alert.bargainTip" tag="p" >
      <span style="color: blue;">{{$t('alert.overseasGoodTip')}}</span>
      <span style="color: blue;">{{$t('alert.overseasGoodTip')}}</span>
    </i18n> -->
    <div class="full_layout position_relative">
      <div class="videoBox" :class="{'videoFull':videoFull}" v-if="videoShow">
        <div class="videoControl">
          <div class="videoBtn">
            <span class="icon_full" @click="videoFull=!videoFull"></span>
            <span class="icon_close" @click="videoShow=false;videoFull=false"></span>
          </div>
          <video-home class="video" />
        </div>
      </div>
      <!-- Shop by Sports/Non-Sports/TCG -->
      <market-show />

      <template v-if="userInfo&&userInfo.MemberSource=='US'">
        <div class="buyitnow_box all_box">
          <router-link :to="{path:'/buynow'}">
            <img src="/static/images/buyitnow.jpg">
          </router-link>
        </div>
      </template>


      <!-- Recommend Sellers -->
      <recommend-swiper />
      <!-- You May Also Like -->
      <like-swiper />
    </div>
    <!-- <questionnaire :domVisible="true" ></questionnaire> -->
    <!-- 获取优惠券 -->
    <!-- <coupon class="home" type="home" :Id="shareId" :Mid="shareMid" @getDialog="getDialog" v-if="isShare" />
    <activity /> -->

    <div class="homeActivity" @click="isActivityTo" v-if="isSwitch">
      <img src="../../../static/images/Activity.png" />
      {{$t('base.Activity')}}
    </div>
  </div>
</template>
<script>
import AvSwiper from "@/components/swiper/advertisement"; //广告
import RecommendSwiper from "@/components/swiper/seller";
import LikeSwiper from "@/components/swiper/like";
import HobbySwiper from "@/components/swiper/manufacturer";
// import Coupon from "@/components/getcoupon";
import VideoHome from "@/components/video";
import MarketShow from "@/components/entry";
// import Activity from "@/components/activity/activity1"; // 新人活动

import Questionnaire from "@/components/dialog/questionnaire"; // 问卷
import { getInfo, resetStoreCategory } from "@/api/public";
export default {
  name: "index",
  components: { RecommendSwiper, LikeSwiper, HobbySwiper, AvSwiper, VideoHome, MarketShow,Questionnaire },
  data() {
    return {
      videoFull:false,
      videoShow:true,
      isSwitch: this.$store.state.isSwitch,
      userInfo: '',
      fid: '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de',
      sid: '10106fda-c5d8-4121-ab21-0428534eaf42',
      shareId: '',
      shareMid: '',
      isShare: false,
      skeletonLoading: false,
      // sports: this.$enumInfo.PropertyList,
      // Logos: this.$enumInfo.facturerLogo,
      SearchCategory: [], //新类目列表
      dislogType: this.$enumInfo.dislogType,
    };
  },
  watch: {
    '$store.state.isSwitch': {
      deep: true,
      handler(obj) {
        //console.log(obj, 'isSwitch')
        this.isSwitch = obj
      }
    }
  },
  mounted() {
  },
  created() {
    //console.log('head1')
    let id = this.$route.query.e
    let mid = this.$route.query.t
    if (id != undefined) {
      this.shareId = id
      this.shareMid = mid
      this.isShare = true
    }
    this.userInfo = getInfo();
    this.getNewCategory()
  },

  methods: {
    isActivityTo() {
      let that = this
      this.$router.push({
        name: 'Activity'
      })
      // if (that.userInfo) {
      //   this.$router.push({
      //     name: 'Activity'
      //   })
      // } else {
      //   this.$router.push({
      //     name: 'Login'
      //   })
      // }
    },
    // 获取类目（新）
    getNewCategory() {
      let that = this
      let data = { AreaCode: 'US'}
      //let data = { AreaCode: 'JP'}
      if (that.userInfo != null) {
        data.AreaCode = that.userInfo.MemberSource
      }
      that.skeletonLoading = true
      // that.SearchCategory
      this.$get(this.$interface.GetCategoryCache, data).then(res => {
        if (res.Result) {

          if (res.Data['FristList']) {
            try{
              let NewCategory=resetStoreCategory(res.Data, ['FristList', 'SecondList', 'ThirdList'])
              
              that.SearchCategory = NewCategory.filter(item=> item.ManufacturerType==0)
            }catch(e){
              console.log(e)
            }
            that.skeletonLoading = false
          }
        }
      })
    },
    getDialog(val) {
      this.isShare = val
    }
  },
};

</script>
<style scoped>
@import "../../../static/css/home.css";

.position_relative{
  position: relative;
}
.position_fixed{
  position: fixed;
}
.logoListBox {
  width: 780px;
  height: 224px;
  overflow: hidden;
}

.skullImg img {
  object-fit: contain;
}

.buyitnow_box img{
  width:100%;
}

.header_menu .shopCardHobby{
  border:1px solid #fff;
  border-radius: 6px 6px 0 0;
  border-bottom:none;
}
.header_menu .shopCardHobby:hover{
  border-color: #5F6DAE;
}
.header_menu .shopCardHobby>a{
  background-color: #fff;
  border-radius: 6px 6px 0 0;
}
.shopCardHobbyBox{
  position: absolute;
  width: 1200px;
  min-height: 20px;
  border:1px solid #5F6DAE;
  background: #fff;
  left: 0;
  top: 28px;
  transform: scaleY(0);
  transform-origin: top center;
  transition: transform .1s ease;
  z-index: 7;
  border-radius: 6px;
  display: grid;
    grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));
    gap: 12px;
    padding: 12px;
}
.shopCardHobbyBox a{
  padding: 0 !important;
}
.shopCardHobbyBox a>img{width:100%}
.header_menu .shopCardHobby:hover .shopCardHobbyBox{
  transform: scaleY(1);
}
.videoBox{
  width: 300px;
    border-radius: 6px;
    overflow: hidden;
    position: fixed;
    bottom: 2%;
    right: 3%;
    z-index: 99;
    box-shadow: 4px 4px 16px 0 rgba(0, 0, 0, 0.40);
}
.videoBox .videoBtn{
  position: absolute;
  z-index: 97;
  display: flex;
  right: 8px;
    top: 8px;
    gap: 8px;
}
.videoBox .videoBtn>span{
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.videoBox .icon_full{
  background: url(../../../static/images/icon/icon_full.png) no-repeat;
  background-size:contain;
}
.videoBox .icon_close{
  background: url(../../../static/images/icon/icon_close.png) no-repeat;
  background-size:contain;
}
.videoBox .video{
  width: 100%;
}
.videoFull{
  width: 100vw;
  height: 100vh;
  bottom: 0;
    right: 0;
    background: rgba(51, 51, 51, 0.60);
}
.videoControl{
}
.videoFull .videoControl{
  width: 1200px;
    border-radius: 12px;
    overflow: hidden;
    margin: 8% auto;
    position: relative;box-shadow: 4.24px 4.24px 16.96px 0 rgba(0, 0, 0, 0.40);
}

</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue